import { makeStyles } from '@material-ui/core';
import { MexIcon } from './MexIcon';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 32,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return <MexIcon className={classes.svg} />;
};
